import { BaseService } from './base.service';
import { CustomResponseEntity, PaginationParams } from '../types/common';
import { TrainingModuleDto, CreateTrainingModuleDto, UpdateTrainingModuleDto } from '../types/dtos/training';
import { api } from '../client/axiosClient';

/**
 * TrainingModuleService handles CRUD operations for training modules.
 *
 * URL Pattern: /api/v1/trainings/{trainingId}/modules
 * Organization context is provided via X-Organization-Id header (injected by axiosClient).
 *
 * Migration: The organizationId parameter has been removed from URL paths. The backend
 * extracts organization context from the X-Organization-Id header for tenant scoping.
 *
 * VAL-FE-006: Training Service Works with Header-Based Auth
 * The axiosClient automatically includes X-Organization-Id header from localStorage,
 * which the backend uses for tenant context validation via TenantContextHolder.
 *
 * @param _organizationId - Deprecated: Organization ID (no longer used, kept for backward compatibility)
 * @param trainingId - Parent training UUID for nested resource path
 */
export class TrainingModuleService extends BaseService<
  TrainingModuleDto,
  CreateTrainingModuleDto,
  UpdateTrainingModuleDto
> {
  /**
   * @param _organizationId - Deprecated: Organization ID (no longer used, kept for backward compatibility)
   * @param trainingId - Parent training UUID for nested resource path
   */
  constructor(_organizationId: string, trainingId: string) {
    super(`/api/v1/trainings/${trainingId}/modules`);
  }

  findAll(params?: PaginationParams): Promise<CustomResponseEntity<TrainingModuleDto[]>> {
    return api.get(this.baseUrl, { params });
  }
}

/**
 * Factory function to create a TrainingModuleService instance
 * @param _organizationId - Deprecated: Organization ID (no longer used, kept for backward compatibility)
 * @param trainingId - Parent training UUID for nested resource path
 */
export const createTrainingModuleService = (_organizationId: string, trainingId: string) => 
  new TrainingModuleService(_organizationId, trainingId);

